var React = require('react');

function Marker (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.6 1.3c5 0 9.3 3.9 9.3 9.3 0 2.3-1.4 5.2-3.7 8.4a48.3 48.3 0 0 1-4.2 5.1 2 2 0 0 1-2.9 0 45.2 45.2 0 0 1-4.2-5c-2.3-3.3-3.7-6.2-3.7-8.5 0-5.4 4.3-9.3 9.4-9.3zm0 11a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.3z","fill":"#161616","fillRule":"nonzero","stroke":"#FFF","strokeWidth":"1.5"}));
}

Marker.defaultProps = {"width":"21","height":"26"};

module.exports = Marker;

Marker.default = Marker;
